import styled from 'styled-components';
import { baseVariables } from '../../styles';
import { toRem } from '@marriott/shared/mi-helper-utils';
import { MTabControlAlignment } from './MTabControl.types';

const { spacers } = baseVariables;

export interface WrapperProps {
  $active?: boolean;
  $alignment?: MTabControlAlignment;
}

const getAlignItems = (alignment?: MTabControlAlignment) => {
  switch (alignment) {
    case MTabControlAlignment.Center:
      return 'center';
    case MTabControlAlignment.Left:
    default:
      return 'flex-start';
  }
};

export const Wrapper = styled.button<WrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: ${props => getAlignItems(props.$alignment)};
  gap: ${spacers?.spacers?.[2] ?? '0.5rem'};
  padding-block: 0 ${spacers?.spacers?.[3] ?? '1rem'};
  padding-inline: 0;
  margin: 0;
  margin-block-end: ${toRem(4)};
  background: transparent;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  ${({ $alignment }) => ($alignment === MTabControlAlignment.Center ? `min-width: ${toRem(44)};` : '')}

  &::after {
    content: '';
    position: absolute;
    inset-inline: 0;
    inset-block-end: ${toRem(-4)};
    block-size: ${toRem(3)};
    background: ${props => (props.$active ? 'var(--t-interactive-accent-color)' : 'transparent')};
    pointer-events: none;
  }

  &:focus-visible {
    outline: 2px solid -webkit-focus-ring-color;
    outline-offset: 2px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const TextBlock = styled.div<{ $alignment?: MTabControlAlignment; $active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${props => getAlignItems(props.$alignment)};
  gap: ${spacers?.spacers?.[2] ?? '0.5rem'};

  .m-tab-control-label {
    color: ${props => (props.$active ? 'var(--t-brand-fg-color)' : 'var(--t-brand-alt-color)')};
  }

  .m-tab-control-description {
    color: var(--t-brand-alt-color);
  }
`;
